import React from 'react';

import Shimmer from 'components/Shimmer';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Info } from '../styles';
import { FlightWrapper, PlaneIcon, Airports, Arrow, ShimmerIcon } from './styles';

type Props = {
  direction: string;
  flightSector: {
    flights: {
      departureAirport: string;
      arrivalAirport: string;
      departureDate: string;
    }[];
  };
};

export const ShimmerFlight = () => (
  <FlightWrapper>
    <ShimmerIcon>
      <Shimmer width="100%" height="100%" />
    </ShimmerIcon>
    <div>
      <Airports>
        <Shimmer>Lorem ipsum dolor.</Shimmer>
      </Airports>
      <Info>
        <Shimmer>Thu, Sep 09 00:00</Shimmer>
      </Info>
      <Info>
        <Shimmer>No stops</Shimmer>
      </Info>
    </div>
  </FlightWrapper>
);

const Flight = ({ direction, flightSector }: Props) => {
  const { t } = useStoreTranslation();
  // (Or number of Stops)
  const zeroIndexFlightCount = flightSector.flights.length - 1;
  const firstFlight = flightSector.flights[0];
  const lastFlight = flightSector.flights[zeroIndexFlightCount];

  return (
    <FlightWrapper>
      <PlaneIcon $direction={direction} />
      <div>
        <Airports>
          {firstFlight.departureAirport} <Arrow /> {lastFlight.arrivalAirport}
        </Airports>
        <Info>{t('tripCard.bookingDateTime', { date: new Date(firstFlight.departureDate) })}</Info>
        {zeroIndexFlightCount === 0 ? (
          <Info>{t('tripCard.noStops')}</Info>
        ) : (
          <Info>{t('tripCard.stop', { count: zeroIndexFlightCount })}</Info>
        )}
      </div>
    </FlightWrapper>
  );
};

export default Flight;
